module.exports = __webpack_public_path__ + "img/product_122.4b72a87.webp";